import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Unauthorized Access</h1>
        <p style={styles.message}>
          You do not have permission to view this page.
        </p>
        {/* <Link to="/" style={styles.button}>
          Go to Login Page
        </Link> */}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#1e3a8a',
    color: 'white',
    fontFamily: 'Arial, sans-serif',
  },
  content: {
    textAlign: 'center',
    padding: '2rem',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
  },
  message: {
    fontSize: '1.2rem',
    marginBottom: '2rem',
  },
  button: {
    padding: '0.8rem 2rem',
    backgroundColor: '#4f83cc',
    color: 'white',
    borderRadius: '5px',
    textDecoration: 'none',
    fontSize: '1.1rem',
    transition: 'background-color 0.3s ease',
  },
};

export default UnauthorizedPage;
